import { __extends } from "tslib";
import { namespacedClassnames } from '../utils';
import ArticlesIcon from './icons/articles.svg';
import TicketsIcon from './icons/tickets.svg';
import { ToolbarContextView } from './toolbar-context/toolbar-context.comp';
import * as ans from '@wix/answers-api';
import * as React from 'react';
import { Tooltip, Icon } from '@wix/answers-ui-libby';
import { isFeatureEnabled } from '@wix/answers-experiments';
export var ToolbarContextSections;
(function (ToolbarContextSections) {
    ToolbarContextSections[ToolbarContextSections["NONE"] = 0] = "NONE";
    ToolbarContextSections[ToolbarContextSections["ARTICLE"] = 1] = "ARTICLE";
    ToolbarContextSections[ToolbarContextSections["TICKET"] = 2] = "TICKET";
    ToolbarContextSections[ToolbarContextSections["CATEGORY"] = 3] = "CATEGORY";
})(ToolbarContextSections || (ToolbarContextSections = {}));
var UserToolbar = /** @class */ (function (_super) {
    __extends(UserToolbar, _super);
    function UserToolbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            contextData: _this.props.contextData,
            currentContext: _this.props.visibleContext
        };
        _this.compTranslate = function (key, params) {
            if (params === void 0) { params = {}; }
            var prefix = _this.props.translationPrefix || 'public.user-toolbar';
            return _this.props.translate(prefix + "." + key, params);
        };
        _this.maybeGetUserRole = function () {
            var _a = _this.props, user = _a.user, translationPrefix = _a.translationPrefix;
            var prefix = translationPrefix ? translationPrefix + ".permission" : 'common.permission';
            return user && user.permissionLevel ? _this.props.translate(prefix + "." + user.permissionLevel) : null;
        };
        _this.stopClickPropagation = function (e) {
            e.stopPropagation();
        };
        return _this;
    }
    UserToolbar.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ contextData: nextProps.contextData, currentContext: nextProps.visibleContext });
    };
    UserToolbar.prototype.render = function () {
        var props = this.props;
        var _a = this.state, currentContext = _a.currentContext, contextData = _a.contextData;
        var isExpanded = this.props.isExpanded ? 'is-expanded' : '';
        var classNames = namespacedClassnames('user-toolbar-container');
        var userName = props.user ? this.compTranslate('info.name', { name: props.user.fullName }) : '';
        var userRole = this.maybeGetUserRole();
        var userRoleComp = userRole ? (React.createElement("span", { className: 'user-role' },
            React.createElement("strong", null, userRole))) : null;
        var userInfoOrWelcomeMessage = userName && userRole ? (React.createElement("span", { className: 'user-info' },
            React.createElement("span", { className: 'user-name' }, userName),
            " | ",
            this.compTranslate('info.logged-in'),
            " ",
            userRoleComp)) : React.createElement("span", { className: 'welcome-message' }, this.compTranslate('info.welcome-message'));
        var articlesUrl = ans.AppNavigator.getAppLink(ans.AppState.HC_ARTICLES, {});
        var ticketsUrl = isFeatureEnabled('OneInbox')
            ? ans.AppNavigator.getAppLink(ans.AppState.HD_ONE_INBOX)
            : ans.AppNavigator.getAppLink(ans.AppState.HD_TICKETS);
        var navContainer = (React.createElement("span", { className: 'nav-container' },
            React.createElement("div", { onClick: this.stopClickPropagation },
                React.createElement(Tooltip, { body: this.compTranslate('nav-tooltip.articles'), relativeToBody: true },
                    React.createElement("a", { href: articlesUrl, target: '_blank', onClick: this.stopClickPropagation, "aria-label": this.compTranslate('nav-tooltip.articles') },
                        React.createElement(Icon, { icon: ArticlesIcon })))),
            React.createElement("div", { onClick: this.stopClickPropagation },
                React.createElement(Tooltip, { body: this.compTranslate('nav-tooltip.tickets'), relativeToBody: true },
                    React.createElement("a", { href: ticketsUrl, target: '_blank', "aria-label": this.compTranslate('nav-tooltip.tickets') },
                        React.createElement(Icon, { icon: TicketsIcon }))))));
        return (React.createElement("div", { className: classNames + " " + isExpanded },
            React.createElement("div", { className: 'user-toolbar-expansion', onClick: props.toggleExpansion },
                React.createElement("div", { className: 'user-toolbar-wrapper' },
                    React.createElement("div", { className: 'user-info-container', onClick: this.stopClickPropagation }, userInfoOrWelcomeMessage),
                    React.createElement(ToolbarContextView, { translate: props.translate, translationPrefix: props.translationPrefix, visibleContext: currentContext, contextData: contextData }),
                    navContainer),
                React.createElement("div", { className: 'toggle-expansion' }))));
    };
    return UserToolbar;
}(React.Component));
export { UserToolbar };
//# sourceMappingURL=user-toolbar.comp.js.map